// Keeps the screen awake during setup and practice (the phone sits on a
// tripod for minutes at a time). Re-acquired when the page becomes visible.

let sentinel: WakeLockSentinel | null = null;
let requesting = false;
let wanted = false;

async function acquire() {
  if (!wanted || sentinel || requesting || !('wakeLock' in navigator) || document.visibilityState !== 'visible') return;
  requesting = true;
  try {
    const s = await navigator.wakeLock.request('screen');
    s.addEventListener('release', () => {
      if (sentinel === s) sentinel = null;
    });
    // Released while the request was in flight: let go straight away.
    if (!wanted) void s.release();
    else sentinel = s;
  } catch {
    sentinel = null;
  } finally {
    requesting = false;
  }
}

document.addEventListener('visibilitychange', () => void acquire());

export function keepAwake(on: boolean): void {
  wanted = on;
  if (on) void acquire();
  else {
    void sentinel?.release();
    sentinel = null;
  }
}

export const wakeLockSupported = () => 'wakeLock' in navigator;
